import { Box, Typography } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { Spacer } from '../Spacer';

interface NavigationArrowProps extends SvgIconProps {
  direction?: 'left' | 'right';
  enabled?: boolean;
  onClick?: (event: React.MouseEvent<any, MouseEvent>) => void;
}

export const NavigationArrow = (props: NavigationArrowProps) => {
  return <>
    <Box sx={{ cursor : props.enabled ? 'pointer' : 'default' }}>
      {props.direction == 'left' && (
        <Box onClick={(event) => props.enabled && props.onClick?.(event)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: props.enabled ? 1 : 0.5 }}>
          <SvgIcon {...props} viewBox="0 0 24 16" fill="none" sx={{ fontSize: '2.5rem', ...props.sx }}>
            <path
              d="M20 8H4M4 8L10 2M4 8L10 14"
              stroke={props.stroke || '#303030'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </SvgIcon>
          <Spacer width="8px" />
          <Typography
            fontSize={25}
            sx ={{ userSelect: 'none' }}
            fontWeight="300"
            letterSpacing="0.3em"
            color={props.stroke || '#303030'}
          >
            PREV
          </Typography>
        </Box>)
      }
      {props.direction == 'right' && (
        <Box onClick={(event) => props.enabled && props.onClick?.(event)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: props.enabled ? 1 : 0.5 }}>
          <Typography
            fontSize={25}
            sx ={{ userSelect: 'none' }}
            fontWeight="300"
            letterSpacing="0.3em"
            color={props.stroke || '#303030'}
          >
            NEXT
          </Typography>
          <Spacer width="8px" />
          <SvgIcon {...props} viewBox="0 0 24 16" fill="none" sx={{ fontSize: '2.5rem', ...props.sx }}>
            <path
              d="M4 8H20M20 8L14 2M20 8L14 14"
              stroke={props.stroke || '#303030'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </SvgIcon>
        </Box>)
      }
    </Box>
  </>
}
